import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-file-list-3-line text-background-50 text-sm"></i>
              </div>
              <span className="font-heading font-bold text-lg text-foreground-900">Vigorbuy Guide</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              The most complete resource platform for Vigorbuy Spreadsheet information, guides, and shopping resources.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
            >
              Visit Main Website
              <i className="ri-arrow-right-up-line text-xs"></i>
            </a>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/shopping-guide" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  Shopping Guide
                </Link>
              </li>
              <li>
                <Link to="/article/vigorbuy-spreadsheet-complete-guide" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  Complete Guide
                </Link>
              </li>
              <li>
                <Link to="/security" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  Security &amp; Privacy
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  Vigorbuy Spreadsheet
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">Top Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">More Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(6).map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Vigorbuy Spreadsheet Guide. All rights reserved.
          </p>
          <p className="text-xs text-foreground-400">
            This is an independent informational resource. Not affiliated with official platforms.
          </p>
        </div>
      </div>
    </footer>
  );
}